'use strict';
import {bindMenuCloseDirective} from './bindMenuCloseDirective';
const angular = require('angular');

module.exports = angular
  .module('app.core-utilities-implementation.ionic-delegates', [])
  .config(require('./ionicListDelegateDecorator.js'))
  .config(require('./ionicSlideBoxDelegateDecorator.js'))
  .config(require('./IonScrollDirectiveDecorator.js'))
  .directive(bindMenuCloseDirective.DIRECTIVE_NAME, bindMenuCloseDirective)
;



// WEBPACK FOOTER //
// ./src/js/core-utilities-implementation/ionic-delegates/index.js